import { Component, Input, OnInit, Output, EventEmitter, ViewChild, ViewEncapsulation } from '@angular/core';
import { Campaign3Service } from '../../services/campaign3.service';
import { Campaign3Info, MessageInstanceObject, JsonSchemaPianificazionePropertiesFormProperties, CalculateFruitionDateRequest, Campaign3StatusMapping } from '../../models/campaign-3.model';
import { FormFields } from '../../components/form-fields/form-fields.component';
import { CouponPianificazioneForm, FruizioneDropdown, GenerazioneDropdown } from '../../models/campaign-3-planning.model';
import { MessageService } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-campaign-3-planning',
  templateUrl: './campaign-3-planning.component.html',
  styleUrls: ['./campaign-3-planning.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class Campaign3PlanningComponent implements OnInit {

  @Input() campaignInfo: Campaign3Info = null;

  @Input() ui_mode: string = this.srvCampaign3.ui_modes.CREATE;
  @Input() coupon_mode: string = this.srvCampaign3.coupon_modes.CREATE;
  @Input() formSchema: any;
  @Input() messageInstanceObject: MessageInstanceObject;
  @Input() comboInizioFruizione: Array<FruizioneDropdown> = [];
  @Input() comboFineFruizione: Array<FruizioneDropdown> = [];
  //@Input() comboGiornoSettimanaInizioFruizione: Array<{value: number,name: string}> = []
  // @Input() comboGiornoSettimanaFineFruizione: Array<{value: number,name: string}> = []
  @Input() readOnly: boolean = false;
  @Input() language: string = "it";
  @Input() dateFormat: string = "dd/MM/yyyy";
  @Input() statusMapping: Campaign3StatusMapping;

  @Output() messageInstanceObjectChange: EventEmitter<MessageInstanceObject> = new EventEmitter<MessageInstanceObject>();
  //@Output() rollingChange:EventEmitter<CalculateFruitionDateRequest> = new EventEmitter<CalculateFruitionDateRequest>();

  @ViewChild('data_inizio_emissione') data_inizio_emissione: FormFields;
  @ViewChild('data_fine_emissione') data_fine_emissione: FormFields;
  @ViewChild('data_inizio_fruizione') data_inizio_fruizione: FormFields;
  @ViewChild('data_fine_fruizione') data_fine_fruizione: FormFields;
  @ViewChild('data_inizio_fruizione_fissa') data_inizio_fruizione_fissa: FormFields;
  @ViewChild('data_fine_fruizione_fissa') data_fine_fruizione_fissa: FormFields;
  @ViewChild('modalita_inizio_fruizione') modalita_inizio_fruizione: FormFields;
  @ViewChild('modalita_fine_fruizione') modalita_fine_fruizione: FormFields;
  @ViewChild('offset_inizio_fruizione') offset_inizio_fruizione: FormFields;
  @ViewChild('offset_fine_fruizione') offset_fine_fruizione: FormFields;
  @ViewChild('giorno_settimana_inizio') giorno_settimana_inizio: FormFields;
  @ViewChild('giorno_settimana_fine') giorno_settimana_fine: FormFields;
  @ViewChild('switchAsEmission') switchAsEmission: FormFields;
  @ViewChild('switchVariabile') switchVariabile: FormFields;



  pianificazioneCouponForm: CouponPianificazioneForm = new CouponPianificazioneForm();

  valid: boolean = true;

  switch = {
    asCampaign: false,
    asEmission: false,
    variable: false
  }

  show = {
    form: false,
    offsetInizioFruizione: false,
    offsetFineFruizione: false,
    fissaInizioFruizione: false,
    fissaFineFruizione: false,
    giorno_settimana_inizio: false,
    giorno_settimana_fine: false,
    errorDate: false
  }

  fieldModel = {
    data_inizio_emissione: null,
    data_fine_emissione: null,
    data_inizio_fruizione: null,
    data_fine_fruizione: null,
    modalita_inizio_fruizione: null,
    modalita_fine_fruizione: null,
    offset_inizio_fruizione: null,
    offset_fine_fruizione: null,
    data_inizio_fruizione_fissa: null,
    data_fine_fruizione_fissa: null,
    giorno_settimana_inizio: null,
    giorno_settimana_fine: null
  }

  errorDateText: string = "Controlla l'intervallo date!";

  //currentFruitionDateRequest: CalculateFruitionDateRequest = null;

  //generazioneDropdown: Array<GenerazioneDropdown> = [];
  //fruizioneDropdown: Array<FruizioneDropdown> = [];

  constructor(
    private srvCampaign3: Campaign3Service,
    private srvMessage: MessageService,
    private translate: TranslateService

  ) {



  }
  ngOnInit() {

    this.show.form = true;

    var self = this;
    setTimeout(function () {

      if(self.data_inizio_emissione)
      self.data_inizio_emissione.required = true;
      if(self.data_fine_emissione)
        self.data_fine_emissione.required = true;
      if(self.data_inizio_fruizione)
      self.data_inizio_fruizione.required = true;
      if(self.data_fine_fruizione)
      self.data_fine_fruizione.required = true;

      if (self.messageInstanceObject && self.ui_mode == self.srvCampaign3.ui_modes.EDIT) {
        self.switch.variable = (self.messageInstanceObject.flgRolling == "1") ? true : false;
        self.fieldModel.modalita_inizio_fruizione = self.comboInizioFruizione ? self.comboInizioFruizione.find(x => x.code == self.messageInstanceObject.couponValidityDateStartMode) : null;
        self.fieldModel.modalita_fine_fruizione = self.comboFineFruizione ? self.comboFineFruizione.find(x => x.code == self.messageInstanceObject.couponValidityDateEndMode) : null;
        self.fieldModel.data_inizio_emissione = self.srvCampaign3.getDateFromDateStringDB(self.messageInstanceObject.startEmissionDate);
        self.fieldModel.data_fine_emissione = self.srvCampaign3.getDateFromDateStringDB(self.messageInstanceObject.endEmissionDate);
        self.fieldModel.data_inizio_fruizione = self.srvCampaign3.getDateFromDateStringDB(self.messageInstanceObject.startFruitionDate);
        self.fieldModel.data_fine_fruizione = self.srvCampaign3.getDateFromDateStringDB(self.messageInstanceObject.endFruitionDate);

        self.data_inizio_emissione.minDate = self.campaignInfo.dateStart;
        self.data_inizio_emissione.maxDate = self.campaignInfo.dateEnd;
        self.data_fine_emissione.minDate = self.campaignInfo.dateStart;
        self.data_fine_emissione.maxDate = self.campaignInfo.dateEnd;
        self.data_inizio_fruizione.minDate = self.campaignInfo.dateStart;
        self.data_inizio_fruizione.maxDate = self.campaignInfo.dateEnd;
        self.data_fine_fruizione.minDate = self.campaignInfo.dateStart;
        self.data_fine_fruizione.maxDate = self.campaignInfo.dateEnd;

        self.fieldModel.data_inizio_fruizione_fissa = self.srvCampaign3.getDateFromDateStringDB(self.messageInstanceObject.couponValidityDateStart);
        self.fieldModel.data_fine_fruizione_fissa = self.srvCampaign3.getDateFromDateStringDB(self.messageInstanceObject.couponValidityDateEnd);
        self.fieldModel.offset_inizio_fruizione = self.messageInstanceObject.couponValidityStartOffsetDay;
        self.fieldModel.offset_fine_fruizione = self.messageInstanceObject.couponValidityEndOffsetDay;

        if (self.fieldModel.modalita_inizio_fruizione) self.onChangeModalitaInizioFruizione(self.fieldModel.modalita_inizio_fruizione, true);
        if (self.fieldModel.modalita_fine_fruizione) self.onChangeModalitaFineFruizione(self.fieldModel.modalita_fine_fruizione, true);
        var self2 = self;
        setTimeout(function () {
          if (self2.giorno_settimana_inizio) {
            self2.fieldModel.giorno_settimana_inizio = self2.giorno_settimana_inizio.options.find(x => x.value == self2.messageInstanceObject.couponValidityStartWeekDay);
          }

          if (self2.giorno_settimana_fine) {
            self2.fieldModel.giorno_settimana_fine = self2.giorno_settimana_fine.options.find(x => x.value == self2.messageInstanceObject.couponValidityEndWeekDay);
          }

        }, 100);
        //wtf? perchè erano impostati così?
       /*  self.fieldModel.data_inizio_fruizione = self.fieldModel.data_inizio_emissione;
        self.fieldModel.data_fine_fruizione = self.fieldModel.data_fine_emissione;
 */
      }
    }, 100);

  }
  resetFruizione() {
    this.fieldModel.data_inizio_fruizione = null;
    this.messageInstanceObject.startFruitionDate = null;

    this.fieldModel.data_fine_fruizione = null;
    this.messageInstanceObject.endFruitionDate = null;

    this.fieldModel.offset_inizio_fruizione = null;
    this.messageInstanceObject.couponValidityStartOffsetDay = null;

    this.fieldModel.offset_fine_fruizione = null;
    this.messageInstanceObject.couponValidityEndOffsetDay = null;

    this.fieldModel.data_inizio_fruizione_fissa = null;
    this.messageInstanceObject.couponValidityDateStart = null;

    this.fieldModel.data_fine_fruizione_fissa = null;
    this.messageInstanceObject.couponValidityDateEnd = null;

    this.fieldModel.modalita_inizio_fruizione = null;
    this.messageInstanceObject.couponValidityDateStartMode = null;

    this.fieldModel.modalita_fine_fruizione = null;
    this.messageInstanceObject.couponValidityDateEndMode = null;

    this.fieldModel.giorno_settimana_inizio = null;
    this.messageInstanceObject.couponValidityStartWeekDay = null;

    this.fieldModel.giorno_settimana_fine = null;
    this.messageInstanceObject.couponValidityEndWeekDay = null;

    //this.messageInstanceObjectChange.emit(this.messageInstanceObject);
  }
  onChangeAsCampaign() {

    /*** si ritorna allo stato iniziale */
    this.resetFruizione();

    var self = this;
    setTimeout(function () {

      self.fieldModel.data_inizio_emissione = self.campaignInfo.dateStart;
      self.messageInstanceObject.startEmissionDate = self.srvCampaign3.getDateStringDBFromDate(self.campaignInfo.dateStart);

      self.fieldModel.data_fine_emissione = self.campaignInfo.dateEnd;
      self.messageInstanceObject.endEmissionDate = self.srvCampaign3.getDateStringDBFromDate(self.campaignInfo.dateEnd);

      //la data minima per l'inizio e la fine fruizione è uguale alla data di inizio emissione, non prima
      if (self.data_inizio_fruizione) {
        self.data_inizio_fruizione.minDate = self.campaignInfo.dateStart;
      }
      if (self.data_fine_fruizione) {
        self.data_fine_fruizione.minDate = self.campaignInfo.dateStart;
      }

      self.messageInstanceObjectChange.emit(self.messageInstanceObject);
    }, 100);

  }


  //Vecchia funzione gestita dallo switch non dal button
  onChangeAsCampaign_OLD(value: boolean) {

    /*** si ritorna allo stato iniziale */
    this.resetFruizione();
    this.switch.variable = false;
    this.switch.asEmission = false;
    var self = this;
    setTimeout(function () {
      if (self.switch.asCampaign == true) {
        self.fieldModel.data_inizio_emissione = self.campaignInfo.dateStart;
        self.messageInstanceObject.startEmissionDate = self.srvCampaign3.getDateStringDBFromDate(self.campaignInfo.dateStart);

        self.fieldModel.data_fine_emissione = self.campaignInfo.dateEnd;
        self.messageInstanceObject.endEmissionDate = self.srvCampaign3.getDateStringDBFromDate(self.campaignInfo.dateEnd);

        //la data minima per l'inizio e la fine fruizione è uguale alla data di inizio emissione, non prima
        if (self.data_inizio_fruizione) {
          self.data_inizio_fruizione.minDate = self.campaignInfo.dateStart;
        }
        if (self.data_fine_fruizione) {
          self.data_fine_fruizione.minDate = self.campaignInfo.dateStart;
        }
      }
      else {
        self.fieldModel.data_inizio_emissione = null;
        self.messageInstanceObject.startEmissionDate = null;

        self.fieldModel.data_fine_emissione = null;
        self.messageInstanceObject.endEmissionDate = null;
      }

      self.messageInstanceObjectChange.emit(self.messageInstanceObject);
    }, 100);

  }
  onChangeAsEmission() {
    this.switch.variable = false;
    this.messageInstanceObject.flgRolling = "0";
    var self = this;
    setTimeout(function () {

      self.resetFruizione();
      if (self.fieldModel.data_inizio_emissione && self.fieldModel.data_fine_emissione) {
        //la data di inizio emissione è la data minima per l'inizio e la fine fruizione
        if (self.fieldModel.data_inizio_emissione) {
          self.data_inizio_fruizione.minDate = self.fieldModel.data_inizio_emissione ? self.fieldModel.data_inizio_emissione : self.campaignInfo.dateStart;
          self.fieldModel.data_inizio_fruizione = self.fieldModel.data_inizio_emissione;
        }
        if (self.fieldModel.data_fine_emissione) {
          self.data_fine_fruizione.minDate = self.fieldModel.data_inizio_emissione ? self.fieldModel.data_inizio_emissione : self.campaignInfo.dateStart;
          self.fieldModel.data_fine_fruizione = self.fieldModel.data_fine_emissione;
        }

      }
      else {
        //la data di inizio campagna è la data minima per l'inizio fruizione
        if (self.data_inizio_fruizione) {
          self.data_inizio_fruizione.minDate = self.campaignInfo.dateStart;
        }
        if (self.data_fine_fruizione) {
          self.data_fine_fruizione.minDate = self.campaignInfo.dateStart;
        }

      }

      self.messageInstanceObjectChange.emit(self.messageInstanceObject);
    }, 100);


  }
  //vecchia gestione dallo switch
  onChangeAsEmission_OLD(value: boolean) {
    this.switch.variable = false;
    this.messageInstanceObject.flgRolling = "0";
    var self = this;
    setTimeout(function () {

      self.resetFruizione();

      if (self.switch.asEmission == true) {
        //la data di inizio emissione è la data minima per l'inizio e la fine fruizione
        if (self.data_inizio_fruizione) {
          self.data_inizio_fruizione.minDate = self.fieldModel.data_inizio_emissione ? self.fieldModel.data_inizio_emissione : self.campaignInfo.dateStart;
          self.fieldModel.data_inizio_fruizione = self.fieldModel.data_inizio_emissione;
        }
        if (self.data_fine_fruizione) {
          self.data_fine_fruizione.minDate = self.fieldModel.data_inizio_emissione ? self.fieldModel.data_inizio_emissione : self.campaignInfo.dateStart;
          self.fieldModel.data_fine_fruizione = self.fieldModel.data_fine_emissione;
        }

      }
      else {
        //la data di inizio campagna è la data minima per l'inizio fruizione
        if (self.data_inizio_fruizione) {
          self.data_inizio_fruizione.minDate = self.campaignInfo.dateStart;
        }
        if (self.data_fine_fruizione) {
          self.data_fine_fruizione.minDate = self.campaignInfo.dateStart;
        }

      }

      self.messageInstanceObjectChange.emit(self.messageInstanceObject);
    }, 100);


  }
  //KS-6483: faccio il reset in modo da assicurarmi di non aver popolato start/end-fruition
  onChangeVariable(value: boolean) {
    var self = this;
    self.resetFruizione();

    if (this.messageInstanceObject.flgCouponingMethod == "S" && (this.srvCampaign3.getStatusNumberFromCode(this.messageInstanceObject.status, this.statusMapping) >= this.statusMapping.actionTypes.number) && value == true) {

      setTimeout(function () {
   
        self.switch.variable = false;
   
        self.srvMessage.add({
          severity: 'error',
          summary: this.srvTranslate.instant('common.error'), 
          detail: this.translate.instant('campaign.static_promotion_warning')
        });
        
        
              })

      return;
    }

    setTimeout(function () {
      self.fieldModel.modalita_inizio_fruizione = null;
      self.messageInstanceObject.couponValidityDateStartMode = null;
      self.fieldModel.modalita_fine_fruizione = null;
      self.messageInstanceObject.couponValidityDateEndMode = null;
      self.resetVariableFieldsInizio();
      self.resetVariableFieldsFine();
      self.switch.asEmission = false;
      //scatta quando cambia l'input switch con date di emissione

      if (self.switch.variable == true) {
        self.modalita_inizio_fruizione.required = true;
        self.modalita_fine_fruizione.required = true;
        self.messageInstanceObject.flgRolling = "1";
        if (self.data_inizio_fruizione_fissa) {
          self.data_inizio_fruizione_fissa.minDate = self.campaignInfo.dateStart;
          self.data_inizio_fruizione_fissa.maxDate = self.campaignInfo.dateEnd;
        }
        if (self.data_fine_fruizione_fissa) {
          self.data_fine_fruizione_fissa.minDate = self.campaignInfo.dateStart;
          self.data_fine_fruizione_fissa.maxDate = self.campaignInfo.dateEnd;
        }
      }
      else {
        if (self.data_inizio_fruizione) {
          self.data_inizio_fruizione.required = true;
          self.data_inizio_fruizione.minDate = self.campaignInfo.dateStart;
          self.data_inizio_fruizione.maxDate = self.campaignInfo.dateEnd;
        }
        if (self.data_fine_fruizione) {
          self.data_fine_fruizione.required = true;
          self.data_fine_fruizione.minDate = self.campaignInfo.dateStart;
          self.data_fine_fruizione.maxDate = self.campaignInfo.dateEnd;
        }
        self.messageInstanceObject.flgRolling = "0";
      }
      self.messageInstanceObjectChange.emit(self.messageInstanceObject);
    }, 100);

  }
  onChangeInizioEmissione(date: Date) {
    if (this.data_inizio_fruizione)
      this.data_inizio_fruizione.minDate = date ? date : this.campaignInfo.dateStart;
    if (this.data_fine_fruizione)
      this.data_fine_fruizione.minDate = date ? date : this.campaignInfo.dateStart;
  }
  onChangeFineEmissione(date: Date) {
    if (this.switch.asEmission == true) {
      this.fieldModel.data_fine_fruizione = date;
    }
  }
  onChangeInizioFruizione(date: Date) {
    if (this.data_fine_fruizione) {
      this.data_fine_fruizione.minDate = date ? date : this.campaignInfo.dateStart;
    }

  }
  onChangeInizioFruizioneFissa(date: Date) {
    /*
    if(this.data_inizio_fruizione_fissa){
      this.data_inizio_fruizione_fissa.minDate = date ? date : this.campaignInfo.dateStart;
    }
    */
  }
  onChangeFineFruizioneFissa(date: Date) {
    /*
    if(this.data_fine_fruizione_fissa){
      this.data_fine_fruizione_fissa.minDate = date ? date : this.campaignInfo.dateStart;
    }
    */
  }
  resetVariableFieldsInizio() {
    if (this.offset_inizio_fruizione) this.offset_inizio_fruizione.required = false;
    if (this.data_inizio_fruizione_fissa) this.data_inizio_fruizione_fissa.required = false;
    if (this.giorno_settimana_inizio) this.giorno_settimana_inizio.required = false;

    this.fieldModel.data_inizio_fruizione_fissa = null;
    this.messageInstanceObject.couponValidityDateStart = null;

    this.fieldModel.offset_inizio_fruizione = null;
    this.messageInstanceObject.couponValidityStartOffsetDay = null;

    this.fieldModel.giorno_settimana_inizio = null;
    this.messageInstanceObject.couponValidityStartWeekDay = null;

    this.show.offsetInizioFruizione = false;
    this.show.fissaInizioFruizione = false;
    this.show.giorno_settimana_inizio = false;

    this.messageInstanceObjectChange.emit(this.messageInstanceObject);
  }
  resetVariableFieldsFine() {
    if (this.offset_fine_fruizione) this.offset_fine_fruizione.required = false;
    if (this.data_fine_fruizione_fissa) this.data_fine_fruizione_fissa.required = false;
    if (this.giorno_settimana_fine) this.giorno_settimana_fine.required = false;

    this.fieldModel.data_fine_fruizione_fissa = null;
    this.messageInstanceObject.couponValidityDateEnd = null;

    this.fieldModel.offset_fine_fruizione = null;
    this.messageInstanceObject.couponValidityEndOffsetDay = null;

    this.fieldModel.giorno_settimana_fine = null;
    this.messageInstanceObject.couponValidityEndWeekDay = null;

    this.show.offsetFineFruizione = false;
    this.show.fissaFineFruizione = false;
    this.show.giorno_settimana_fine = false;

    this.messageInstanceObjectChange.emit(this.messageInstanceObject);
  }
  onChangeModalitaInizioFruizione(dropdownFruizione: GenerazioneDropdown, firstEditLoad: boolean = false) {

    var self = this;
    if (!firstEditLoad) {
      this.resetVariableFieldsInizio();
    }
    else {
      setTimeout(function () {
        self.modalita_inizio_fruizione.required = true;
      }, 100);
    }

    //NOTA: un valore come START.VAL.CPN.DAY è conosciuto a priori
    this.messageInstanceObject.couponValidityDateStartMode = (this.fieldModel.modalita_inizio_fruizione && this.fieldModel.modalita_inizio_fruizione.code) ? this.fieldModel.modalita_inizio_fruizione.code : null;

    if (dropdownFruizione.code == "START.VAL.CPN.DAY.OFFSET") {
      //dayOfGenerationOffset
      //giorno di generazione + offset
      this.show.offsetInizioFruizione = true;
      setTimeout(function () {
        self.offset_inizio_fruizione.required = true;
      }, 100);
    }
    else if (dropdownFruizione.code == "START.VAL.CPN.DAY") {
      //dayOfGeneration
      //giorno di generazione

    }
    else if (dropdownFruizione.code == "START.VAL.CPN.DATE") {
      //fixed date
      //data fissa
      //l'utente dovrà scegliere le due date
      this.show.fissaInizioFruizione = true;
      setTimeout(function () {
        self.data_inizio_fruizione_fissa.required = true;
      }, 100);
    }
    else if (dropdownFruizione.code == "START.VAL.CPN.LAST.MONTH.DAY.GEN") {
      //lastDayOfMonthGeneration
      //ultimo giorno del mese successivo alla generazione

    }
    else if (dropdownFruizione.code == "START.VAL.CPN.FIRST.DAY.GEN") {
      //firstDayOfMonthFollowingGeneration
      //primo giorno del mese successivo alla generazione

    }
    else if (dropdownFruizione.code == "START.VAL.CPN.NEXT.DAY.GEN") {
      //dayofWeekFollowingGeneration
      //giorno settimana successiva al giorno di generazione
      this.show.giorno_settimana_inizio = true;
      setTimeout(function () {
        self.giorno_settimana_inizio.required = true;
      }, 100);
    }
    // this.onChangeRolling();
  }

  onChangeModalitaOffsetStartFruizione(){
    this.messageInstanceObject.couponValidityStartOffsetDay = this.fieldModel.offset_inizio_fruizione ? this.fieldModel.offset_inizio_fruizione : null;
    this.messageInstanceObjectChange.emit(this.messageInstanceObject);
  } 

   onChangeModalitaOffsetFineFruizione(){
    this.messageInstanceObject.couponValidityEndOffsetDay = this.fieldModel.offset_fine_fruizione ? this.fieldModel.offset_fine_fruizione : null;
    this.messageInstanceObjectChange.emit(this.messageInstanceObject);
  } 

  onChangeModalitaFineFruizione(dropdownFruizione: GenerazioneDropdown, firstEditLoad: boolean = false) {
    var self = this;

    if (!firstEditLoad) {
      this.resetVariableFieldsFine();
    }
    setTimeout(function () {
      self.modalita_fine_fruizione.required = true;
    }, 100);

    //NOTA: un valore come END.VAL.CPN.DAY è conosciuto a priori
    //NOTA: un valore come START.VAL.CPN.DAY è conosciuto a priori
    this.messageInstanceObject.couponValidityDateEndMode = (this.fieldModel.modalita_fine_fruizione && this.fieldModel.modalita_fine_fruizione.code) ? this.fieldModel.modalita_fine_fruizione.code : null;


    if (dropdownFruizione.code == "END.VAL.CPN.DAY.OFFSET") {
      //dayOfGenerationOffset
      //giorno di generazione + offset
      this.show.offsetFineFruizione = true;
      setTimeout(function () {
        self.offset_fine_fruizione.required = true;
      }, 100);
    }
    else if (dropdownFruizione.code == "END.VAL.CPN.DAY") {
      //dayOfGeneration
      //giorno di generazione
    }
    else if (dropdownFruizione.code == "END.VAL.CPN.DATE") {
      //fixed date
      //data fissa
      //l'utente dovrà scegliere le due date
      this.show.fissaFineFruizione = true;
      setTimeout(function () {
        self.data_fine_fruizione_fissa.required = true;
      }, 100);
    }
    else if (dropdownFruizione.code == "END.VAL.CPN.LAST.MONTH.DAY.GEN") {
      //lastDayOfMonthGeneration
      //ultimo giorno del mese successivo alla generazione

    }
    else if (dropdownFruizione.code == "END.VAL.CPN.FIRST.DAY.GEN") {
      //firstDayOfMonthFollowingGeneration
      //primo giorno del mese successivo alla generazione

    }
    else if (dropdownFruizione.code == "END.VAL.CPN.NEXT.DAY.GEN") {
      //dayofWeekFollowingGeneration
      //settimana successiva al giorno di generazione
      this.show.giorno_settimana_fine = true;
      setTimeout(function () {
        self.giorno_settimana_fine.required = true;
      }, 100);

      //   this.onChangeRolling();
    }

  }
  /*
  onChangeRolling(){
    this.currentFruitionDateRequest = new CalculateFruitionDateRequest();
    this.currentFruitionDateRequest.flg_rolling = "1";
    this.currentFruitionDateRequest.start_fruition_date = this.srvCampaign3.getDateStringDBFromDate(this.fieldModel.data_inizio_fruizione);
    this.currentFruitionDateRequest.end_fruition_date =  this.srvCampaign3.getDateStringDBFromDate(this.fieldModel.data_fine_fruizione);  
    this.currentFruitionDateRequest.coupon_validity_date_start_mode = (this.fieldModel.modalita_inizio_fruizione && this.fieldModel.modalita_inizio_fruizione.code) ? this.fieldModel.modalita_inizio_fruizione.code : null;
    this.currentFruitionDateRequest.coupon_validity_date_start = this.srvCampaign3.getDateStringDBFromDate(this.fieldModel.data_inizio_fruizione_fissa);
    this.currentFruitionDateRequest.coupon_validity_start_offset_day =  this.fieldModel.offset_inizio_fruizione;
    this.currentFruitionDateRequest.coupon_validity_start_week_day = this.fieldModel.giorno_settimana_inizio ? this.fieldModel.giorno_settimana_inizio.day : null;
    this.currentFruitionDateRequest.coupon_validity_date_end_mode = (this.fieldModel.modalita_fine_fruizione && this.fieldModel.modalita_fine_fruizione.code) ? this.fieldModel.modalita_fine_fruizione.code : null;
    this.currentFruitionDateRequest.coupon_validity_date_end = this.srvCampaign3.getDateStringDBFromDate(this.fieldModel.data_fine_fruizione_fissa);
    this.currentFruitionDateRequest.coupon_validity_end_offset_day = this.fieldModel.offset_fine_fruizione;
    this.currentFruitionDateRequest.coupon_validity_end_week_day = this.fieldModel.giorno_settimana_fine ? this.fieldModel.giorno_settimana_fine.day : null;
    this.rollingChange.emit(this.currentFruitionDateRequest);
  }
  */
  /*
   onChangeGiornoSettimana(){
     if(this.giorno_settimana_inizio && this.giorno_settimana_inizio.fieldModel && this.giorno_settimana_inizio.fieldModel.value){
       this.currentFruitionDateRequest.coupon_validity_start_week_day = this.giorno_settimana_inizio.fieldModel.value;
     }
     if(this.giorno_settimana_fine && this.giorno_settimana_fine.fieldModel && this.giorno_settimana_fine.fieldModel.value){
       this.currentFruitionDateRequest.coupon_validity_end_week_day = this.giorno_settimana_fine.fieldModel.value;
     }
     //this.rollingChange.emit(this.currentFruitionDateRequest);
   }
   */
  onChangeGiornoSettimana() {
    if (this.giorno_settimana_inizio && this.giorno_settimana_inizio.fieldModel && this.giorno_settimana_inizio.fieldModel.value) {
      this.messageInstanceObject.couponValidityStartWeekDay = this.giorno_settimana_inizio.fieldModel.value;
    }
    if (this.giorno_settimana_fine && this.giorno_settimana_fine.fieldModel && this.giorno_settimana_fine.fieldModel.value) {
      this.messageInstanceObject.couponValidityEndWeekDay = this.giorno_settimana_fine.fieldModel.value;
    }
    this.messageInstanceObjectChange.emit(this.messageInstanceObject);
    //this.rollingChange.emit(this.currentFruitionDateRequest);
  }
  /*
  onChangeOffsetInizioFruizione(value: any){
    this.messageInstanceObject.couponValidityStartOffsetDay = value;
    this.messageInstanceObjectChange.emit(this.messageInstanceObject);
  }
  */
   async performValidationPlanning(): Promise<boolean >{

    await this.calculateFruitionDates()

    if (this.data_inizio_emissione) this.data_inizio_emissione.performValidation();
    if (this.data_fine_emissione) this.data_fine_emissione.performValidation();
    if (this.data_inizio_fruizione) this.data_inizio_fruizione.performValidation();
    if (this.data_fine_fruizione) this.data_fine_fruizione.performValidation();
    if (this.modalita_inizio_fruizione) this.modalita_inizio_fruizione.performValidation();
    if (this.modalita_fine_fruizione) this.modalita_fine_fruizione.performValidation();
    if (this.data_inizio_fruizione_fissa) this.data_inizio_fruizione_fissa.performValidation();
    if (this.data_fine_fruizione_fissa) this.data_fine_fruizione_fissa.performValidation();
    if (this.offset_inizio_fruizione) this.offset_inizio_fruizione.performValidation();
    if (this.offset_fine_fruizione) this.offset_fine_fruizione.performValidation();
    if (this.giorno_settimana_inizio) this.giorno_settimana_inizio.performValidation();
    if (this.giorno_settimana_fine) this.giorno_settimana_fine.performValidation();

    let error = false;

    if (
      (this.data_inizio_emissione && !this.data_inizio_emissione.valid) ||
      (this.data_fine_emissione && !this.data_fine_emissione.valid) ||
      (this.data_inizio_fruizione && !this.data_inizio_fruizione.valid) ||
      (this.data_fine_fruizione && !this.data_fine_fruizione.valid) ||
      (this.modalita_inizio_fruizione && !this.modalita_inizio_fruizione.valid) ||
      (this.modalita_fine_fruizione && !this.modalita_fine_fruizione.valid) ||
      (this.data_inizio_fruizione_fissa && !this.data_inizio_fruizione_fissa.valid) ||
      (this.data_fine_fruizione_fissa && !this.data_fine_fruizione_fissa.valid) ||
      (this.offset_inizio_fruizione && !this.offset_inizio_fruizione.valid) ||
      (this.offset_fine_fruizione && !this.offset_fine_fruizione.valid) ||
      (this.giorno_settimana_inizio && !this.giorno_settimana_inizio.valid) ||
      (this.giorno_settimana_fine && !this.giorno_settimana_fine.valid)
    )
      error = true;

    //altre condizioni sulle date
    this.checkDateErrors();
    if (this.show.errorDate == true)
      error = true;

    if (error == true) {
      this.valid = false;
    }
    else {
      this.valid = true;
    }
    return this.valid;

  }
  //nuova funzione PROMISE in modo da aspettare il check dei dati cambiando dentro al subscribe i valori
  private calculateFruitionDates(): Promise<void> {
    return new Promise((resolve, reject) => {
       
    
        const payload = new CalculateFruitionDateRequest();
        payload.flg_rolling = this.messageInstanceObject.flgRolling;
        payload.end_fruition_date = this.srvCampaign3.getDateStringDBFromDate(this.fieldModel.data_fine_fruizione);
        payload.start_fruition_date=this.srvCampaign3.getDateStringDBFromDate(this.fieldModel.data_inizio_fruizione);
        payload.coupon_validity_date_start_mode = this.messageInstanceObject.couponValidityDateStartMode;
        payload.coupon_validity_date_start = this.messageInstanceObject.couponValidityDateStart;
        payload.coupon_validity_start_offset_day = this.messageInstanceObject.couponValidityStartOffsetDay;
        payload.coupon_validity_start_week_day = this.messageInstanceObject.couponValidityStartWeekDay;
        payload.coupon_validity_date_end_mode = this.messageInstanceObject.couponValidityDateEndMode;
        payload.coupon_validity_date_end = this.messageInstanceObject.couponValidityDateEnd;
        payload.coupon_validity_end_offset_day = this.messageInstanceObject.couponValidityEndOffsetDay;
        payload.coupon_validity_end_week_day = this.messageInstanceObject.couponValidityEndWeekDay;
        payload.id = this.messageInstanceObject.id;
        payload.end_emission_date = this.srvCampaign3.getDateStringDBFromDate(this.fieldModel.data_fine_emissione);
        payload.start_emission_date=this.srvCampaign3.getDateStringDBFromDate(this.fieldModel.data_inizio_emissione);
      //aggiunta il 09/05/2025
          this.srvCampaign3.calculateFruitionDate(payload).subscribe({
            next: res => {
              if (res) {
          
                if (!res.fruition_date_start) {
                  console.error('Errore: fruition_date_start è assente o non valido');
                } else {
                  this.messageInstanceObject.startFruitionDate = res.fruition_date_start;
                  this.fieldModel.data_inizio_fruizione = this.getDateFromDateStringDB(res.fruition_date_start);
                }
          
                if (!res.fruition_date_end) {
                  console.error('Errore: fruition_date_end è assente o non valido');
                } else {
                  this.messageInstanceObject.endFruitionDate = res.fruition_date_end;
                  this.fieldModel.data_fine_fruizione = this.getDateFromDateStringDB(res.fruition_date_end);
                }
          
                if (!this.fieldModel.data_fine_emissione) {
                  console.error('Errore: data_fine_emissione è assente o non valido');
                } else {
                  this.messageInstanceObject.endEmissionDate = this.getDateStringDBFromDate(this.fieldModel.data_fine_emissione);
                }
          
                if (!this.fieldModel.data_inizio_emissione) {
                  console.error('Errore: data_inizio_emissione è assente o non valido');
                } else {
                  this.messageInstanceObject.startEmissionDate = this.getDateStringDBFromDate(this.fieldModel.data_inizio_emissione);
                }
          
              } else {
                console.error('Errore: la risposta del servizio è nulla o non valida');
              }
          
              resolve(); // Completa la Promise con successo
            },
            error: err => reject(err) // In caso di errore
          });
          
      
    });
  }


  getDateFromDateStringDB(dateStringDB: string): Date | null {
    let res = null;
    if (dateStringDB && dateStringDB.length == 10) {

      // Dividi la stringa in parti separate
      const dateParts: string[] = dateStringDB.split("-");
      const year: number = parseInt(dateParts[0]);
      const month: number = parseInt(dateParts[1]) - 1; // I mesi in JavaScript vanno da 0 a 11
      const day: number = parseInt(dateParts[2]);

      // Crea un oggetto Date
      res = new Date(year, month, day);
    }
    return res;
  }


  getDateStringDBFromDate(date: Date): string | null {
    let res = null;
    if (date) {
      let anno: number = date.getFullYear();
      let mese: number = date.getMonth() + 1; // Month è 0-based, quindi aggiungiamo 1
      let giorno: number = date.getDate();

      // Aggiungi zeri iniziali se il mese o il giorno sono inferiori a 10
      let meseStringa: string = mese < 10 ? '0' + mese : '' + mese;
      let giornoStringa: string = giorno < 10 ? '0' + giorno : '' + giorno;

      res = anno + "-" + meseStringa + "-" + giornoStringa;
    }
    return res;
  }







  checkDateErrors() {
    this.show.errorDate = false;

     
    const rules = new Set([
      {
        condition: () => (this.fieldModel.data_inizio_emissione && this.campaignInfo.dateStart && (this.fieldModel.data_inizio_emissione < this.campaignInfo.dateStart)),
        errorMessage: "La data di inizio emissione non può essere inferiore alla data di inizio della campagna"
      },
      {
        condition: () => (this.fieldModel.data_inizio_emissione && this.campaignInfo.dateEnd && (this.fieldModel.data_inizio_emissione > this.campaignInfo.dateEnd)),
        errorMessage: "La data di inizio emissione non può essere superiore alla data di fine della campagna"
      },
      {
        condition: () => (this.fieldModel.data_inizio_fruizione && this.campaignInfo.dateStart && (this.fieldModel.data_inizio_fruizione < this.campaignInfo.dateStart)),
        errorMessage: "La data di inizio fruizione non può essere inferiore alla data di inizio della campagna"
      },
      {
        condition: () => (this.fieldModel.data_inizio_fruizione && this.campaignInfo.dateEnd && (this.fieldModel.data_inizio_fruizione > this.campaignInfo.dateEnd)),
        errorMessage: "La data di inizio fruizione non può essere superiore alla data di fine della campagna"
      },
      {
        condition: () => (this.fieldModel.data_fine_emissione && this.campaignInfo.dateStart && (this.fieldModel.data_fine_emissione < this.campaignInfo.dateStart)),
        errorMessage: "La data di fine emissione non può essere inferiore alla data di inizio della campagna"
      },
      {
        condition: () => (this.fieldModel.data_fine_emissione && this.campaignInfo.dateEnd && (this.fieldModel.data_fine_emissione > this.campaignInfo.dateEnd)),
        errorMessage: "La data di fine emissione non può essere superiore alla data di fine della campagna"
      },
      {
        condition: () => (this.fieldModel.data_fine_fruizione && this.campaignInfo.dateStart && (this.fieldModel.data_fine_fruizione < this.campaignInfo.dateStart)),
        errorMessage: "La data di fine fruizione non può essere inferiore alla data di inizio della campagna"
      },
      {
        condition: () => (this.fieldModel.data_fine_fruizione && this.campaignInfo.dateEnd && (this.fieldModel.data_fine_fruizione > this.campaignInfo.dateEnd)),
        errorMessage: "La data di fine fruizione non può essere superiore alla data di fine della campagna"
      },
      {
        condition: () => (this.fieldModel.data_inizio_fruizione && this.fieldModel.data_inizio_emissione && (this.fieldModel.data_inizio_fruizione < this.fieldModel.data_inizio_emissione)),
        errorMessage: "La data di inizio fruizione deve essere superiore alla data di inizio emissione"
      },
      {
        condition: () => (this.fieldModel.data_inizio_fruizione && this.fieldModel.data_fine_fruizione && (this.fieldModel.data_inizio_fruizione > this.fieldModel.data_fine_fruizione)),
        errorMessage: "La data di inizio fruizione deve essere inferiore alla data di fine fruizione"
      },
      {
        condition: () => (this.fieldModel.data_fine_fruizione && this.fieldModel.data_inizio_emissione && (this.fieldModel.data_fine_fruizione < this.fieldModel.data_inizio_emissione) && (this.srvCampaign3.getStatusNumberFromCode(this.messageInstanceObject.status, this.statusMapping) >= this.statusMapping.emissionConditions.number)),
        errorMessage: "La data di fine fruizione non può essere inferiore alla data di inizio emissione"
      },

      {
        condition: () => (this.fieldModel.data_fine_fruizione && this.fieldModel.data_inizio_fruizione && (this.fieldModel.data_fine_fruizione < this.fieldModel.data_inizio_fruizione)),
        errorMessage: "La data di fine fruizione non può essere inferiore alla data di inizio fruizione"
      },
      //newCondition
      {
        condition: () => (this.fieldModel.data_fine_fruizione && this.fieldModel.data_fine_emissione && (this.fieldModel.data_fine_fruizione < this.fieldModel.data_fine_emissione)),
        errorMessage: "La data di fine fruizione deve essere superiore  alla data di fine emissione"
      }
    ]);

    var self = this;
    rules.forEach(rule => {

      if (rule.condition()) {
        self.errorDateText = rule.errorMessage;
        self.show.errorDate = true;
      }
    });

  }
}



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/views/campaign-3-planning/campaign-3-planning.component.ts